module.exports = __webpack_public_path__ + "img/icons_4.66949dec.svg";